import { CreativeTagEvent, ViewabilityEventConditions } from '../enums';
import { TimerService } from '../services/timer/timer-service';
import { EventEmitter } from '../types';
import { ViewabilityObserver } from '../types/viewability-observer';

const VIEW_COUNTDOWN_THRESHOLD_MS = 1000; // 1 second

export class ViewEventNotifier {
  private isEventEmitted = false;

  constructor(
    observer: ViewabilityObserver,
    private readonly emitter: EventEmitter<CreativeTagEvent>,
    private readonly timer: TimerService = new TimerService()
  ) {
    this.timer.subscribe(this.handleTick.bind(this));

    observer.on(ViewabilityEventConditions.On50PercentVisible, () => {
      this.timer.delay = VIEW_COUNTDOWN_THRESHOLD_MS;
      this.timer.resume();
    });
    observer.on(ViewabilityEventConditions.OnNotVisible, () => {
      this.timer.pause();
    });
  }

  private handleTick(elapsedMs: number) {
    if (!this.isEventEmitted && elapsedMs >= VIEW_COUNTDOWN_THRESHOLD_MS) {
      this.emitter.emit(CreativeTagEvent.CreativeView);
      this.clear();
    }
  }

  private clear() {
    this.isEventEmitted = true;
    this.timer.pause();
    this.timer.unsubscribe(this.handleTick.bind(this));
  }
}
